















































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'
import { NameFormState } from './nameFormState'

@Component
export default class NameForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  firstName: string

  @Prop({ default: '' })
  lastName: string

  @Prop({ default: false })
  isRequired: boolean

  @Prop({ required: true })
  handleFormUpdated: (val: NameFormState) => void

  @Prop({ default: '' })
  namePrefix: string

  @Prop({ default: true })
  isHeaderVisible: boolean

  get formState(): NameFormState {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
    }
  }

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  get validation(): any {
    // TODO: バリデーションルールの整理
    // 本来、必要最小限の内容を含むバリデーションルールを複数組み合わせることで、必要なバリデーションを組み上げたい。
    // 過剰に大きな unusable_character というルールを使いまわしていることで、regexで例外を定義する必要が生じている。
    return {
      required: this.isRequired,
      max: 10,
      regex: /^[^0-9・_\-　\s]+$/,
      unusable_emoji: true,
      unusable_character: true,
      contains_tab: true,
    }
  }

  nameWithPrefix(name: string) {
    return !!this.namePrefix ? `${this.namePrefix}-${name}` : name
  }

  handleInputFirstName(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      firstName: input,
    })
  }

  handleInputLastName(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      lastName: input,
    })
  }
}
